import { HandleErrorAndLoading } from "@common/handleErrorAndLoading/HandleErrorAndLoading";
import { Modal } from "@common/Modal/Modal";
import { TITLE_INHERIT_STYLE } from "@constants";
import { useTerminateNumber } from "@features/TerminateNumber/hook/useTerminateNumber";
import { Grid, Card, CardHeader, CardContent, Typography, Button } from "@material-ui/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IFetchState } from "src/itsf/fetch/fetcherUtils";

interface IParams {
    date: string;
    postTerminationNumberCancellationStatus: IFetchState;
    postNumberTerminationCancellation: () => void;
}

const TerminationStatus = (props: IParams) => {
    const { date, postTerminationNumberCancellationStatus, postNumberTerminationCancellation } = props;
    const { t } = useTranslation("accountDetails");
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    const handleCancelTerminationClick = () => {
        setIsModalOpen(true);
    };

    return (
        <Grid item xs={12}>
            <Card elevation={2}>
                <CardHeader
                    className="card-header card-header__right"
                    title={t("terminationStatus")}
                    titleTypographyProps={TITLE_INHERIT_STYLE}
                    style={{ backgroundColor: "#4a148c" }}
                />
                <CardContent>
                    <div className="card-header__circle" style={{ backgroundColor: "#4a148c" }} />
                    <HandleErrorAndLoading
                        error={postTerminationNumberCancellationStatus.error}
                        isLoading={postTerminationNumberCancellationStatus.isLoading}
                    >
                        <Grid item xs={12} style={{ textAlign: "center" }}>
                            <Typography color="secondary" variant="body2">
                                {t("terminationScheduledOn", { terminationDate: date })}
                            </Typography>
                        </Grid>
                        <Grid container justify="center" style={{ marginTop: "15px" }}>
                            <Grid item>
                                <Button
                                    color="secondary"
                                    type="button"
                                    variant="outlined"
                                    onClick={handleCancelTerminationClick}
                                >
                                    {t("cancelTermination")}
                                </Button>
                            </Grid>
                        </Grid>
                    </HandleErrorAndLoading>
                </CardContent>
            </Card>
            <Modal
                close={() => setIsModalOpen(false)}
                confirm={() => {
                    setIsModalOpen(false);
                    postNumberTerminationCancellation();
                }}
                content={t("cancelTerminationModalText")}
                isModalOpen={isModalOpen}
                title={t("cancelTerminationModalTitle")}
            />
        </Grid>
    );
};

export default TerminationStatus;
